import React from 'react';

const ProductSection = () => {
  return (
    <section className="section-grey section-top-border" id="product">
      <div className="container">
        <div className="row">
          {/* Section Title and Subtitle */}
          <div className="col-md-12 text-center">
            <h2 className="section-title">Integrated solutions designed for your business</h2>
            <p className="section-subtitle">
              Delivering customized web and mobile app solutions for your unique business goals.
            </p>
          </div>

          {/* Service 1: Select your template */}
          <div className="col-md-4">
            <div className="main-services">
              <i className="lni lni-files mb-4"></i>
              <h3>Select your template</h3>
              <p>
                Our app builder comes with pre-loaded templates that are tailored to your application. To get
                started, simply choose your template.
              </p>
              {/* Uncomment to add a button */}
              {/* <a href="#about" className="btn-blue-line small scrool">InstaApp for Designers</a> */}
            </div>
          </div>

          {/* Service 2: Add your content */}
          <div className="col-md-4">
            <div className="main-services">
              <i className="lni lni-control-panel mb-4"></i>
              <h3>Add your content</h3>
              <p>
                Create products and engaging content for your application to stand out and attract a large
                number of users who will become loyal users.
              </p>
              {/* Uncomment to add a button */}
              {/* <a href="#about" className="btn-blue-line small scrool">InstaApp for Marketers</a> */}
            </div>
          </div>

          {/* Service 3: Get your App live */}
          <div className="col-md-4">
            <div className="main-services">
              <i className="lni lni-fireworks mb-4"></i>
              <h3>Get your App live</h3>
              <p>
                Our application maker wizard makes it super simple to make your brand new app live.
              </p>
              {/* Uncomment to add a button */}
              {/* <a href="#about" className="btn-blue-line small scrool">InstaApp for Agencies</a> */}
            </div>
          </div>
        </div>
      </div>
    </section>


    
  );
};

export default ProductSection;
